import { render, staticRenderFns } from "./AboutHistoryHeader.vue?vue&type=template&id=2715f928&"
import script from "./AboutHistoryHeader.vue?vue&type=script&lang=js&"
export * from "./AboutHistoryHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports